/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Integrations_Binding_Test_Failed_DetailInputs */



/**
* | output |
* | --- |
* | "Connection test failed: {error}" |
*
* @param {Integrations_Binding_Test_Failed_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_binding_test_failed_detail = /** @type {((inputs: Integrations_Binding_Test_Failed_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Binding_Test_Failed_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verbindungstest fehlgeschlagen: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Connection test failed: ${i?.error}`)
});